import qs from 'query-string';
import { useService } from '@atlassian/jira-common-services/src/use-service';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

const BASE_URL = '/rest/api/3/search';

type SearchOptions = {
	jql: string;
	/*
	 * See @atlassian/jira-platform-field-config for the list of applicable fields.
	 * Ensure this array is constant to avoid an infinite loop.
	 */
	fields?: string[];
	maxResults?: number;
};

// Fields that are returned by default (when 'fields' is not passed with the query)
// This is not yet comprehensive, update accordingly
type DefaultIssueFields = {
	summary: string;
};

export type SearchResponse<IssueFields extends {} = DefaultIssueFields> = {
	total: number;
	issues: Array<{
		id: string;
		key: string;
		fields: IssueFields;
	}>;
};

const search = <IssueFields extends {} = DefaultIssueFields>({
	jql,
	fields = [],
	maxResults = 50,
}: SearchOptions) => {
	const query = qs.stringify({
		jql,
		fields,
		maxResults,
	});

	return performGetRequest<SearchResponse<IssueFields>>(`${BASE_URL}?${query}`);
};

export const useIssueSearch = <IssueFields extends {} = DefaultIssueFields>() =>
	useService<SearchResponse<IssueFields>, SearchOptions>(search);
